$(document).ready(function () {
    setMenuEvents();
    initLoginPage();
});
function IsBlocked() {
    var current = parseInt($("#hdnCurrent").val() == null ? "0" : $("#hdnCurrent").val().toString());
    var limit = parseInt($("#hdnLimit").val() == null ? "0" : $("#hdnLimit").val().toString());
    //alert(current + ' - ' + limit);
    return current >= limit;
}
var setMenuEvents = function () {
    $('.selector--main-menu .nav-item').hover(function () {
        if ($(this).hasClass('nav-item-home')) {
            $('.sub-sidebar').addClass('invisible');
            return;
        }
        var submenu = $(this).data('submenu');
        if ($('.' + submenu).length == 0) {
            $('.sub-sidebar').addClass('invisible');
            return;
        }
        $('.sub-sidebar').removeClass('invisible');
        $('.nav-item-submenu').css('z-index', '1');
        $('.' + submenu).css('z-index', '100').hide().removeClass('d-none').show();
    }, function () {
        //if ($(this).find('.nav-link').hasClass('active')) {
        //    return;
        //}
        // $(this).find('.nav-link').removeClass('active');
        return;
        // var submenu = $(this).data('submenu');
        // $('.' + submenu).hide().addClass('d-none').css('z-index', '1');
    });
    $('.sidebar').hover(function () {
        return;
    }, function () {
        $('.nav-item-submenu').hide().addClass('d-none').css('z-index', '1');
        // $('.selector--main-menu .nav-link').removeClass('active');
        $('.sub-sidebar').addClass('invisible');
    });
    // set position of the home buttom
    var calculateHomeButtonPosition = function () {
        var menuHeight = 0;
        $('.selector--main-menu .nav-item').each(function () {
            menuHeight += $(this).height();
        });
        var windowHeight = $(window).height();
        var headerHeight = $('.header').height();
        var homeBtnHeight = $('.nav-item-home').height();
        var documentHeight = $(document).height();
        var minPosition = documentHeight - menuHeight - headerHeight; // - (2 * homeBtnHeight);
        var scrollTop = $(document).scrollTop();
        var windowBottom = documentHeight - scrollTop - windowHeight;
        if (windowBottom > minPosition) {
            windowBottom = minPosition;
        }
        if (windowBottom < 0) {
            windowBottom = 0;
        }
        $('.nav-item-home').css('bottom', windowBottom + 'px');
    };
    $(document).scroll(function () {
        calculateHomeButtonPosition();
    });
    $(document).ready(function () {
        calculateHomeButtonPosition();
    });
    $('a[href="/products/add"], a[href="/content/articles/add"], a[href="/content/events/add"]').on('click', function () {
        // check fullAccessModal
        //if ($('#fullAccessModal').length) {
        //    $('#fullAccessModal').modal('show');
        //    return false;
        //}
        if (IsBlocked()) {
            $('#fullAccessModal').modal('show');
            return false;
        }
    });
    calculateHomeButtonPosition();
};
var initLoginPage = function () {
    $('.form-signin .email-tooltip').hover(function () {
        if ($(this).find('.pop-over').length > 0)
            return;
        var popOver = '<div class="pop-over">Enter an email address that matches a listed contact on your account</div>';
        $(this).append($(popOver));
    }, function () {
        $(this).find('.pop-over').remove();
    });
    $('.form-signin').submit(function (e) {
        $("#ckbRememberMe").val($("#ckbRememberMe").prop("checked"));
    });
};
/*******************Cookie************************/
function setCookie(cname, cvalue, ex) {
    var d = new Date();
    d.setTime(d.getTime() + (ex * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
